import { useLingui } from '@lingui/react/macro';
import { Import } from '@remarkable/ark-icons';

import { ComponentLocations } from 'src/analytics/trackingTypes';
import type { Payment } from 'src/api/endpoints/storeApi.types';
import { Button, Tooltip } from 'src/components';
import { formatDate } from 'src/utils/formatDate';

export const ReceiptLink = ({ payment }: { payment: Payment }) => {
  const { t } = useLingui();
  const paymentDate = formatDate(payment.createdAt);

  return (
    <Tooltip title={t`See receipt on Stripe`}>
      <Button
        as="a"
        to={payment.receiptUrl ?? ''} // We check for null in the parent component
        target="_blank"
        rel="noreferrer"
        variant="tertiary"
        size="medium"
        analytics={{
          text: 'arrow-square-out icon',
          location: ComponentLocations.MANAGE_CONNECT.MAIN,
          action: 'open receipt on stripe',
        }}
        aria-label={t`Invoice link for payment made on ${paymentDate}`}
      >
        <Import size={24} />
      </Button>
    </Tooltip>
  );
};
